<template>
  <svg
    :class="className"
    fill="none"
    :height="height"
    viewBox="0 0 24 24"
    :width="width"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path clip-rule="evenodd" d="M1.94595 12C1.94595 6.45154 6.45154 1.94595 12 1.94595C17.5485 1.94595 22.0541 6.45154 22.0541 12C22.0541 17.5485 17.5485 22.0541 12 22.0541C6.45154 22.0541 1.94595 17.5485 1.94595 12ZM12 0C5.37683 0 0 5.37683 0 12C0 18.6232 5.37683 24 12 24C18.6232 24 24 18.6232 24 12C24 5.37683 18.6232 0 12 0ZM15.9312 8.06878C16.3112 8.44874 16.3112 9.0648 15.9312 9.44477L13.376 12L15.9312 14.5553C16.3112 14.9352 16.3112 15.5513 15.9312 15.9313C15.5513 16.3112 14.9352 16.3112 14.5552 15.9313L12 13.376L9.44475 15.9313C9.06478 16.3112 8.44873 16.3112 8.06876 15.9313C7.68879 15.5513 7.68879 14.9352 8.06876 14.5553L10.624 12L8.06876 9.44477C7.68879 9.0648 7.68879 8.44874 8.06876 8.06878C8.44873 7.68881 9.06478 7.68881 9.44475 8.06878L12 10.624L14.5552 8.06878C14.9352 7.68881 15.5513 7.68881 15.9312 8.06878Z" :fill="fill" fill-rule="evenodd"/>
  </svg>
</template>

<script>
export default {
  name: 'TimesCircle',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    height: {
      type: String,
      required: false,
      default: '100%'
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
    fill: {
      type: String,
      required: false,
      default: '#000'
    },
  },
};

</script>
